import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { DropDownComponentBase } from './drop-down.base.component';

import { CommonService } from '../../_services';
import { ICountry, IGeographicRegion, ICity } from '../../_entities';

@Component({
    selector: 'city-dropdown',
    template: require('./dropdown.template.html'),
    styles: ['input[type=text] { margin-top:10px; }']
})
export class CityDropDownComponent extends DropDownComponentBase<ICity> {
    private country: ICountry;
    private region: IGeographicRegion;

    constructor(private commonService: CommonService) {
        super();
    }

    ngOnInit() {
        this.isDisabled = (!this.country || !this.region);
    }
    getDisplayValue(item: ICity) {
        return item.name;
    }

    getItems(): Promise<ICity[]> {
        if (!this.country || !this.region) {
            return null;
        }
        return this.commonService.getCitiesInRegion(this.region);
    }
    mapItem(items: ICity[], item: ICity): ICity {
        return items.find(x => {
            return x.region.country.code === item.region.country.code && x.region.name === item.region.name && x.name === item.name
        });
    }
    onItemSelected(item: ICity) {
        this.selectedItemChange.emit(item);
    }

    private handleChangedPreReq() {
        this.updateItemList();
        if ((!this.country || !this.region || this.selectedItem == null || (this.selectedItem.region.country.code != this.country.code || this.selectedItem.region.name != this.region.name)) && this.selectedItem) {
            this.setSelectedItem(null);
        }

        this.isDisabled = (!this.country || !this.region);
    }

    @Input("country") set countryBinding(val: ICountry) {
        this.country = val;
        this.handleChangedPreReq();
    }
    @Input("region") set regionBinding(val: IGeographicRegion) {
        this.region = val;
        this.handleChangedPreReq();
    }
    @Input("selectedCity") set selectedItemBinding(val: ICity) {
        if (val != this.selectedItem)
            this.setSelectedItem(val);
    }
    @Output("selectedCityChange") selectedItemChange = new EventEmitter<ICity>();
    
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/city-dropdown.component.ts